<template>
  <div class="landing-page confirm">

    <div class="content-container">
      <!-- Hero banner -->
      <div class="hero-banner">
        <div class="container">
          <h1>Confirm booking</h1>
        </div>
      </div>

      <div class="container">
          <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <booking-lookup-form @lookupComplete="$router.push({name: 'confirmBooking'})" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
  .landing-page{
    flex-grow: 1;
  }
</style>